import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { ServiceAreaSection } from "@/components/ServiceAreaSection";
import { WhyChooseUs } from "@/components/WhyChooseUs";

import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { RecentWork } from "@/components/RecentWork";
import { HomeFAQ } from "@/components/HomeFAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Plumber Gulf Shores AL | 24/7 Emergency | Onyx Professional Plumbing",
    "description": "Onyx Professional Plumbing — Gulf Shores, Orange Beach & Foley's trusted plumber. 24/7 emergency service, water heaters, drain cleaning & remodeling. Call (251) 504-4452.",
    "url": "https://onyxprofessionalplumbing.com",
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": ["h1", ".hero-description"]
    },
    "mainEntity": {
      "@type": "LocalBusiness",
      "@id": "https://onyxprofessionalplumbing.com/#organization"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://onyxprofessionalplumbing.com"
      }]
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Plumber Gulf Shores, Orange Beach & Foley AL | Onyx"
        description="Trusted plumbers in Gulf Shores, Orange Beach & Foley, AL. 24/7 emergency service, water heaters, whole-home water filtration, leak & faucet repair. Call (251) 504-4452."
        canonical="https://onyxprofessionalplumbing.com"
        schema={homeSchema}
      />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <ServiceAreaSection />
        
        <Team />
        <Testimonials />
        <RecentWork />
        <HomeFAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
